import Backbone from 'backbone';
import Clip from 'models/clip';

class Clips extends Backbone.Collection {}

Clips.prototype.model = Clip;

export default Clips;
